import { QueryClient } from "@tanstack/react-query";
import orderBy from "lodash/orderBy";
import { GetStaticPaths, GetStaticProps } from "next";
import dynamic from "next/dynamic";

import { getPage, getPagesOfType } from "@src/lib/api";
import getFooterSection from "@src/services/contentful/footer/getFooterMenu";
import { getHeaderMenuGraphQL } from "@src/services/contentful/mainHeader/getMainHeader";

import findAndPopulateCollection from "@src/lib/api-util/FindAndPopulateCollection";
import getBlogIndexEntry from "@src/services/contentful/post/getBlogIndexEntry";
import { getSiteSettingsGql } from "@src/services/contentful/settings/settings";
import getTags from "@src/services/contentful/tag/getTags";
import { useBreadCrumbsQueryQuery } from "@src/components/atoms/Breadcrumbs/__generated/Breadcrumbs.generated";
import { getBreadcrumbsGql } from "@src/services/contentful/breadcrumbs/breadcrumbs";
import { IPageFields } from "@src/types/generated/contentful";

export { default } from "@src/pages/page";

const BLOG_PAGE_SIZE = 20;
export async function getPageStaticProps(data: any, pageTypeDelete: string) {
  const { params } = data;

  const preview =   data?.preview || false;

  const queryClient = new QueryClient();


  const settings = await getSiteSettingsGql({
    queryClient,
    preview,
  });




  const slugLength = params?.slug ? params?.slug?.length - 1 : 0;
  const slug = params?.slug
    ? params?.slug[slugLength]?.toString().toLowerCase()
    : "404";
  let page = await getPage({
    slug,
    preview,
    //    pageContentType: pageType,
  });

  const breadcrumbs = await getBreadcrumbsGql({
    slug,
    preview,
    queryClient,
  });

  const pageFields = page?.fields as IPageFields;
  let pageContentType = pageFields?.content?.sys?.contentType?.sys?.id;

  // get additional data for different page types
  let tags = null;
  let blogPages = null;
  if (pageContentType === "pageBlogIndex") {

    tags = await getTags(preview);

    blogPages = await getPagesOfType({
      pageContentType: "pageBlogPost",
      query: {
        order: "-fields.pubDate",
      },
    });

    // order blog pages because the query above doesn't work
    orderBy(blogPages, "fields.content.fields.date");

    page = await getBlogIndexEntry({
      preview,
      includeContent: true,
      query: {
        limit: BLOG_PAGE_SIZE,
      },
    });

    //TODO: get rid of the side effect
    findAndPopulateCollection(page, "Blog Posts", blogPages);

    // Builds the RSS xml feed
    if (typeof window === 'undefined') {
      const generateRssFeed = require("@src/services/contentful/post/generateRssFeed");

      if (generateRssFeed && typeof generateRssFeed === "function") {
        await generateRssFeed({ blogPages, currentPageSlug: slug });
      }
    }
  }

  // get error page if page not found
  if (!page) {
    page = await getPage({
      slug: "404",
      preview,
      pageContentType: "pageErrorPage",
    });
    pageContentType = "pageErrorPage";
  }

  let footerMenu = await getFooterSection({
    query: {
      limit: 1,
      include: 5,
      select: "sys.id,sys.contentType,sys.type,fields",
    },
    preview,
  });

  let headergql = await getHeaderMenuGraphQL({
    preview: data?.preview || false,
    queryClient,
  });

  // footerMenu = deepOmit(footerMenu, [
  //   "metadata",
  //   "environment",
  //   "createdAt",
  //   "updatedAt",
  //   "revision",
  //   "space",
  //   "locale",
  // ]);

  // page = deepOmit(page, [
  //   "metadata",
  //   "environment",
  //   "createdAt",
  //   "updatedAt",
  //   "revision",
  //   "space",
  //   "locale",
  // ]);

  // header = deepOmit(header, [
  //   "metadata",
  //   "environment",
  //   "createdAt",
  //   "updatedAt",
  //   "revision",
  //   "space",
  //   "locale",
  // ]);

  return {
    props: {
      settings, // ALL PAGES
      consentVisible: true, // ??? PAGES
      preview, // ALL PAGES
      header: headergql, // ALL PAGES
      footerMenu, // everything but landing pages
      pageContentType,
      breadcrumbs, // ALL PAGES

      // blog
      tags, // blog only
      collection: blogPages, // blog only
      page, // generic page, blog index, blog post page only
    },
  };
}

export async function getPageStaticPaths(
  data: any,
  pageType: string,
  path?: string
) {
  //console.log("genericPages:[slug]", data);
  //console.log("CONTENTFUL_ENVIRONMENT", process.env.CONTENTFUL_ENVIRONMENT);
  // const entries: EntryCollection<Pick<IPageFields, "slug">> = await getClient(
  //   false
  // ).getEntries({
  //   content_type: "pageGenericPage",
  //   //select: "slug",
  // });
  if (!path) {
    path = "";
  }

  const entries = await getPagesOfType({
    pageContentType: pageType,
  });

  //console.log("entries: ", entries);
  // entries
  //   .filter(({ sys }) => sys?.contentType?.sys?.id === "pageGenericPage")
  //   .map(({ fields }) =>
  //     console.log("[slug]:entries", JSON.stringify(sys?.contentType?.sys?.id))
  //   );
  // entries
  //   .filter(
  //     ({ fields }) =>
  //       fields?.content?.sys?.contentType?.sys?.id === "pageGenericPage"
  //   )
  //   .map(({ fields }) =>
  //     console.log("[slug]:entries", fields?.content?.sys?.contentType?.sys?.id)
  //   );
  const paths = entries
    .filter(
      ({ fields }: any) =>
        fields?.content?.sys?.contentType?.sys?.id === pageType
    )
    .map(({ fields }: any) => `${path}/${fields?.slug.toLowerCase()}`);

  return {
    paths,
    fallback: true,
  };
}

export const getStaticProps: GetStaticProps = async (data) => {
  return await getPageStaticProps(data, "pageGenericPage");
};

export const getStaticPaths: GetStaticPaths = async (data) => {
  return await getPageStaticPaths(data, "pageGenericPage");
};
